import styled from "styled-components";

export const AfterLoginLayoutWrapper = styled.div`
  ${"" /* position: relative; */}
  ${"" /* left: 50%; */}
  ${"" /* ${(props) => // console.log("PROPSSSS: ", props)} */}
  width: ${(props) => (props.width ? props.width : "60%" || "60%")};
  ${"" /* transform: translateX(-50%); */}
  display: flex;
  margin: 0px auto;
  flex-direction: column;
  ${"" /* justify-content: center; */}
  margin-bottom: 0px;
  padding-bottom: 0px;
  ${"" /* background-color: red; */}
  ${"" /* background-color: orange; */}
  min-height: 78vh;
  flex: 1;
  .first-child {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
  }
  .details-btn-row {
    display: flex;
    flex-direction: row;
    gap: 14px;
    justify-content: center;
    margin-top: 10px;
    padding-top: 10px;
    margin-bottom: 10px;
  }

  .details-btn {
    background-color: #fcfcfc;
    font-size: 20px;
    border: 1px solid #e9e9e9;
    border-radius: 10px;
    padding: 10px 10px;
    color: #212121;
    width: 100%;
    text-align: center;
  }

  .colored {
    border-color: #c6222a;
    color: #c6222a;
  }

  .bottomDiv {
    display: flex;
    flex-direction: column;
    flex-grow: 3;
    justify-content: flex-end !important;
  }

  .only-btn {
    display: flex;
    align-items: flex-end !important;
    margin-bottom: 0px;
    padding-bottom: 0px;
    gap: 0px;
  }

  .no-btn {
    display: flex;
    align-items: flex-end !important;
    margin-bottom: 50px;
    padding-bottom: 0px;
    gap: 0px;
  }

  @media only screen and (max-width: 768px) {
    width: ${(props) => (props.width ? props.width : "80%" || "80%")};
    ${"" /* width: 75%; */}
  }

  @media only screen and (max-width: 533px) {
    ${"" /* width: 80%; */}
  }
`;
